<div class="p-heading-area01" role="dialog" aria-label="Trip summary">
  <h2
    class="p-heading-area01__title c-heading-2"
    [innerHTML]="'label.itinerary2' | staticMsg"
    role="heading"
    aria-level="2"
  ></h2>
</div>
<div class="p-trip-summary">
  <ng-container *ngFor="let bound of bounds; let boundIdx = index">
    <div class="p-trip-summary__item">
      <div class="p-trip-summary__title">
        <asw-bound-title [boundIdx]="boundIdx"></asw-bound-title>
      </div>
      <div
        [ngClass]="[
          'p-trip-summary__contents',
          isLastFlightCanceled(boundIdx) ? 'p-trip-summary__contents--gray10' : ''
        ]"
      >
        <div class="p-trip-summary__contents-item" role="dialog" aria-label="Bound Detail">
          <div class="p-flight-detail01">
            <ng-container
              *ngFor="let flight of bound.flights ?? []; let flightIdx = index; let isFirst = first; let isLast = last"
            >
              <asw-flight-item
                [boundIdx]="boundIdx"
                [flightIdx]="flightIdx"
                [isFirstFlight]="isFirst"
                [isLastFlight]="isLast"
              ></asw-flight-item>
              <!-- (1.1.54) 乗継情報(セグメント) & (1.1.16) セグメント情報 (1 & 2.8)  -->
              <ng-container
                *ngIf="
                  getConnection(flightIdx, bound?.flights, flight.arrival?.locationCode, flight.connectionTime);
                  let connection
                "
              >
                <!-- (1.1.19) フライト時間ライン (4)
                  4) 当該セグメント情報.connectionTimeが存在する、かつ以下のいずれかを満たす場合、以下のように表示する。-->
                <div
                  *ngIf="!isLast && connection.isShow"
                  [ngClass]="[
                    'p-flight-detail01__block',
                    flight.statusCode === 'UN' ? 'p-flight-detail01__block--gray10' : ''
                  ]"
                >
                  <!--
                    4.1) 当該バウンド.flights[当該セグメントのインデックス].arrival.locationCode ≠
                         当該バウンド.flights[当該セグメントのインデックス+1].departure.locationCodeの場合、細い点線 を表示する。
                    4.2) 当該バウンド.flights[当該セグメントのインデックス].arrival.locationCode =
                         当該バウンド.flights[当該セグメントのインデックス+1].departure.locationCodeの場合、細い実線を表示する。
                  -->
                  <div
                    [ngClass]="[
                      'p-flight-detail01__item p-flight-detail01__item--2col',
                      connection.isSameLocation
                        ? 'p-flight-detail01__item--transit'
                        : 'p-flight-detail01__item--transfer'
                    ]"
                  >
                    <div class="p-flight-detail01__line p-flight-detail01__line--route-middle js-fix-vl-1"></div>
                    <div class="p-flight-detail01__time">
                      <!-- (1.1.55) 乗継時間 -->
                      <div class="p-flight-detail01__time-item">
                        <span
                          class="p-flight-detail01__time-elapsed"
                          [innerHTML]="
                            getFlightConnectionTime(flight.connectionTime) | dateFormat : 'default_flightTotalTime'
                          "
                        ></span>
                      </div>
                    </div>
                    <!-- (1.1.56) 乗継情報 -->
                    <div class="p-flight-detail01__detail">
                      <div class="p-flight-detail01__detail-item">
                        <span
                          [ngClass]="[
                            connection.isSameLocation
                              ? 'p-flight-detail01__detail-transit'
                              : 'p-flight-detail01__detail-transfer'
                          ]"
                          [innerHTML]="getLocationName(connection.isSameLocation, flight.arrival?.locationCode)"
                        ></span>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
    <!-- (1.1.59) 乗継情報(バウンド間) -->
    <div *ngIf="isNextBound(boundIdx)" class="p-trip-summary__other">
      <!-- (1.1.60) 地上間移動文言
        当該バウンド.isOtherMethodsConnection=true(バウンドが「次バウンドとの関係がARNKである」)の場合、
        異なる都市間の地上移動が必要な旨を表示する。-->
      <div *ngIf="bound.isOtherMethodsConnection" class="p-trip-summary__other-item">
        <div class="p-trip-summary__other-text" [innerHTML]="'label.arnk' | staticMsg"></div>
      </div>
    </div>
  </ng-container>
</div>
